import { Link } from "react-router-dom";

export const Logo = ({ size = "text-4xl", className = "" }) => {
  return (
    <Link
      to="/"
      data-testid="phusic-logo"
      className={`font-logo text-white select-none leading-none tracking-wide ${size} ${className}`}
      style={{ textShadow: "0 2px 24px rgba(0,0,0,0.7)" }}
    >
      Phusic
    </Link>
  );
};
